module.exports = __webpack_public_path__ + "static/media/ivy.1ea5df1c.jpg";